import { ref } from '@vue/composition-api'
import axios from 'axios'

// const orderPartsListAsc = partsList => partsList.sort().join('|')

const joinPartsList = specOrderePartsList => specOrderePartsList.join('|')

export default function useResolvedPorductNumber () {
  let resolvedProductNumber = ref(null)

  const tryResolveProductNumber = async (partsList, whipLengthA = '', whipLengthB = '') => {
    try {
      let response = await axios.post(process.env.VUE_APP_PRODUCT_RESOLVE_API_URL, {
        partsList: joinPartsList(partsList),
        whipLengths: `${whipLengthA}|${whipLengthB}`.replace(/\|$/, '') 
      })
      
      if (response.data.length == 1) {
        resolvedProductNumber.value = response.data[0].productNumber
        // eslint-disable-next-line
        // console.log(resolvedProductNumber.value)
      }
      
      if (response.data.length > 1) {
        // eslint-disable-next-line
        // console.log(response.data.forEach(e => console.log(e.productNumber)))
      }

    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
    }
  }

  return {
    resolvedProductNumber,
    tryResolveProductNumber
  }
}